import { dataMinusCircleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMinusCircleSolid = /*#__PURE__*/createIcon(dataMinusCircleSolid)
export default IconMinusCircleSolid
